import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalSimpleTableFilterService {
  public filter<T, U>(rowsData: T[], selectedFilters: U): T[] {
    let filterableRows: T[] = rowsData;

    if (selectedFilters && Object.keys(selectedFilters).length < 1) {
      return rowsData;
    }

    for (const [key, value] of Object.entries(selectedFilters)) {
      filterableRows = filterableRows.filter(rowData => rowData[value.data.field] === value.id);
    }

    return filterableRows;
  }
}
